import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetFeaturedProductQuery } from "../../products/productSlice";
import FeaturedProduct from "./featured-product/FeaturedProduct";
import QuiekViewModal from "../../../pages/QueikViewModal/QuiekViewModal";
import { featuredDB } from "../../../rki-data/category";
import axios from "axios";
import { base_url } from "../../../server";
import { useTranslation } from "react-i18next";

import product1 from "../../../assets/img/products/1.jpg";
import product2 from "../../../assets/img/products/2.jpg";
import product3 from "../../../assets/img/products/3.jpg";
import product4 from "../../../assets/img/products/4.jpg";
import product5 from "../../../assets/img/products/5.jpg";
import product6 from "../../../assets/img/products/6.jpg";
import product7 from "../../../assets/img/products/7.jpg";
import product8 from "../../../assets/img/products/8.jpg";

import Rating from "../../../shared/rating/Rating";

function FeaturedProducts() {
  const [data, setData] = useState();
  const [error, seterror] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const baseUrl = base_url();
  const getdata = async (page) => {
    setisLoading(true);
    try {
      // const res = await axios.get(`https://onlineparttimejobs.in/api/product/page/${page}&${12}`, { withCredentials: true })
      const res = await axios.get(`${baseUrl}product/page/0&10000`, {
        withCredentials: true,
      });
      setData(res.data);
      setisLoading(false);
    } catch (error) {
      console.log("server error");
      seterror(true);
      setisLoading(false);
    }
  };
  useEffect(() => {
    getdata(0);
  }, []);
  console.log("data -", data);
  const [modelDataId, setModelDataId] = useState(null);
  const setProduct_id = (id) => {
    setModelDataId(id);
  };

  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setModelDataId(id);
    setShow(true);
  };

  const sortedData = useMemo(() => {
    return data?.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
  }, [data]);

  // Custom product Data
  const custom = [
    {
      id: 1,
      url: product1,
      title: "Advi Decorative Zamioculcas Zamiifolia Plant",
      price: "499",
    },
    {
      id: 2,
      url: product2,
      title: "Alobtt Plants Mini Potted Artificial Plants",
      price: "599",
    },
    {
      id: 3,
      url: product3,
      title: "Peace Lily Large Ceramic Caladium Potted Plant",
      price: "2,299",
    },
    {
      id: 4,
      url: product4,
      title: "Exotic Rare Plants Small Jute Modern Plant",
      price: "2,299",
    },
    {
      id: 5,
      url: product5,
      title: "Posh Garden Rosemary Salvia Indoor Plant",
      price: "1100",
    },
    {
      id: 6,
      url: product6,
      title: "Royal Land Tree Philodendron Plant & Self watering Pot",
      price: "779",
    },
    {
      id: 7,
      url: product7,
      title: "Dracaena Trifasciata Big Ornamental Plant",
      price: "433",
    },
    {
      id: 8,
      url: product8,
      title: "Tied Artificial Swiss Cheese Potted Plant with",
      price: "2,299.00",
    },
    // {
    //   id: 9,
    //   url: product9,
    //   title: "première decalcifying pre-shampoo concentrate",
    //   price: "Rs. 2,299.00",
    // },
    // {
    //   id: 10,
    //   url: product10,
    //   title: "discover the new première for all types of damaged hair",
    //   price: "Rs. 4,29.00",
    // },
    // {
    //   id: 11,
    //   url: product11,
    //   title: "discover the new première for all types of damaged hair",
    //   price: "Rs. 1,299.00",
    // },
    // {
    //   id: 12,
    //   url: product5,
    //   title: "discover the new première for all types of damaged hair",
    //   price: "Rs. 2,200",
    // },
  ];
  // Custom product Data

  return (
    <>
      <section className="productsSection sectionPD">
        <div className="container">
          <div className="row featuredRow">
            <div className="col-lg-12">
              <div className="fishermanHeader ">
                <div className="fisherman-content">
                  <h6>{t("Newly Arrived Products")}</h6>
                  <h3>{t("Explore New Arrivals")}</h3>
                </div>
                <div className="fisherman-btn d-none">
                  <Link to="/products" className="optional-btn">
                    View More
                  </Link>
                </div>
              </div>
            </div>

            <div className="categoryWrapper row d-none">
              {custom.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-6">
                      <div className="featuredInfo products">
                        <div className="featuredImg">
                          <img
                            src={item.url}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>
                        <div className="featuredContent">
                          <Rating />
                          <h5 className="mb-2">{item.title}</h5>
                          <span>
                            MRP:{" "}
                            <span className="text-decoration-line-through">
                              ₹1100.00
                            </span>
                          </span>

                          <p className="mb-0">Sale Price: ₹{item.price}.00</p>

                          <div className="buyNowInfo">
                            <Link
                              className="btn btn-danger buyNow"
                              onClick={() => {
                                // BuyNowItem(item);
                              }}
                              to={`/product/${item._id}`}
                            >
                              Buy Now
                            </Link>

                            <Link
                              // onClick={() => handleAddCart(item)}
                              to={`/product/${item?.uid}/${item.slug}`}
                              className="buyNow"
                            >
                              {t("Cart")}{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>

            <FeaturedProduct
              data={sortedData}
              getFeaturedPro={getdata}
              isLoading={isLoading}
              error={error}
              handleShow={handleShow}
              setProduct_id={setProduct_id}
            />
          </div>
        </div>

        {/* {modelDataId && (
          <QuiekViewModal modelDataId={modelDataId} show={show} onHide={handleClose} size="xl"
            centered />
        )} */}
      </section>
    </>
  );
}

export default FeaturedProducts;
